import {toAnalyticsInteger} from './data-layer-utils';

function getItemSku ( item ) {
    return item?.product?.sku || item?.sku || item?.itemId || item?.item_id;
}

export function parseServerCartAdditions ( search = '' ) {
    if ( !search ) {
        return [];
    }

    const additions = [];
    const params = new URLSearchParams( search );

    params.getAll( 'items' ).forEach( value => {
        String( value || '' ).split( '|' ).forEach( pair => {
            const tokens = pair.split( ',' ).map( token => token.trim() );

            if ( tokens.length !== 2 ) {
                return;
            }

            const [sku, rawQuantity] = tokens;
            const quantity = toAnalyticsInteger( rawQuantity );
            if ( sku && quantity !== null && quantity > 0 ) {
                additions.push( {sku, quantity} );
            }
        } );
    } );

    return additions;
}

export function parseConfirmedServerCartAdditions ( root = document ) {
    const source = root?.querySelector?.( '[data-confirmed-cart-additions]' );

    if ( !source ) {
        return [];
    }

    try {
        const additions = JSON.parse( source.getAttribute( 'data-confirmed-cart-additions' ) || '{}' );

        return Object.keys( additions ).map( sku => ( {
            sku,
            quantity: toAnalyticsInteger( additions[sku] )
        } ) ).filter( addition => addition.sku && addition.quantity !== null && addition.quantity > 0 );
    }
    catch ( err ) {
        return [];
    }
}

export function getServerCartAdditionItems ( cartItems = [], confirmedAdditions = [] ) {
    return confirmedAdditions
        .map( addition => {
            const cartItem = cartItems.find( item => getItemSku( item ) === addition.sku );
            return cartItem ? {...cartItem, quantity: addition.quantity} : null;
        } )
        .filter( item => item != null );
}
